/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {ocrCard} from '../api'

export const useMutationOcrCard = createReactQueryMutationHook('ocrCard', ocrCard)
